import React, { useEffect, useState } from "react";

import styles from "./AddStatementPage.module.css";
// import classnames from "classnames";
import { useHistory } from "react-router-dom";
import useAddStatement from "../../hooks/useAddStatement";
import { useManifestoContext } from "../../context/ManifestoContext";
import useManifesto from "../../hooks/useManifesto";
import PageHeader from "../App/PageHeader";
import ContentSection from "../App/ContentSection";
import Button from "../UserInterfaceElements/Button";
import DarkPage from "../UserInterfaceElements/DarkPage";

const AddStatementPage: React.FC = () => {
  const [text, setText] = useState<string>("");
  const [source, setSource] = useState<string>("");
  const [sourceAuthor, setSourceAuthor] = useState<string>("");
  const [sourceLink, setSourceLink] = useState<string>("");
  // const [addToMyManifesto, _setAddToMyManifesto] = useState(true);
  const addToMyManifesto = true;
  const { add, statement } = useAddStatement();
  const { add: manifestoAdd, setPublicCount, myManifesto } = useManifestoContext();
  const { manifesto } = useManifesto( myManifesto && myManifesto.uuid ? myManifesto.uuid : "" );
  const history = useHistory();

  const [saving, setSaving] = useState(false);

  const maxStatementLength = 280;

  useEffect(() => {
    if (statement) {
      if (addToMyManifesto && manifesto) {
        setPublicCount(manifesto.publicCount + 1);
        manifestoAdd(statement);
      }
      history.push(`/statement/${statement.id}`);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statement, addToMyManifesto, manifestoAdd, history]);

  return (<DarkPage >
    <div className={styles.AddStatementPage}>
      <PageHeader className={styles.Header}>Contribute Statement</PageHeader>
      <ContentSection>
        <p style={text.length === maxStatementLength ? {color: "red" } : {} } className={styles.CharacterCount}>{text.length} / {maxStatementLength} characters</p>
        <textarea value={text} onChange={(evt) => setText(evt.target.value)} maxLength={maxStatementLength} placeholder={"Write a statement"} style={{marginBottom:"10px"}}/>
        <label>
          {/* Source (optional) */}
          <input
            placeholder="Source (optional)"
            value={source}
            maxLength={140}
            onChange={(evt) => setSource(evt.target.value)}
          />
        </label>
        <label>
          {/* Source Author (optional) */}
          <input
            placeholder="Source Author (optional)"
            value={sourceAuthor}
            maxLength={64}
            onChange={(evt) => setSourceAuthor(evt.target.value)}
          />
        </label>
        <label>
          {/* Source link (optional) */}
          <input
            placeholder="URL (optional)"
            value={sourceLink}
            onChange={(evt) => setSourceLink(evt.target.value)}
          />
        </label>
        {/* <label>
          Add to my manifesto
          <input
            type="checkbox"
            checked={addToMyManifesto}
            onChange={(evt) => setAddToMyManifesto(evt.target.checked)}
          />
        </label> */}
        <Button disabled={!text || saving} onClick={() => {setSaving(true); return add(text.replace(new RegExp("(^(\"|')*|(\"|')*$)*", "g"), ""), source, sourceLink, sourceAuthor)}}>
          {saving ? <div className={styles.DotContainer}><div className={styles.DotFlashing}></div></div>: "add statement"}
        </Button>
      </ContentSection>
    </div></DarkPage>
  );
};

export default AddStatementPage;
